export const autocompleteOptions = {
  InputProps: { autoComplete: "no" },
};
